/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getDiscriminatedUnionDecoder,
  getDiscriminatedUnionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type GetDiscriminatedUnionVariant,
  type GetDiscriminatedUnionVariantContent,
  type ReadonlyUint8Array,
} from '@solana/kit';

export type LeafSchema =
  | {
      __kind: 'V1';
      id: Address;
      owner: Address;
      delegate: Address;
      nonce: bigint;
      dataHash: ReadonlyUint8Array;
      creatorHash: ReadonlyUint8Array;
    }
  | {
      __kind: 'V2';
      id: Address;
      owner: Address;
      delegate: Address;
      nonce: bigint;
      dataHash: ReadonlyUint8Array;
      creatorHash: ReadonlyUint8Array;
      collectionHash: ReadonlyUint8Array;
      assetDataHash: ReadonlyUint8Array;
      flags: number;
    };

export type LeafSchemaArgs =
  | {
      __kind: 'V1';
      id: Address;
      owner: Address;
      delegate: Address;
      nonce: number | bigint;
      dataHash: ReadonlyUint8Array;
      creatorHash: ReadonlyUint8Array;
    }
  | {
      __kind: 'V2';
      id: Address;
      owner: Address;
      delegate: Address;
      nonce: number | bigint;
      dataHash: ReadonlyUint8Array;
      creatorHash: ReadonlyUint8Array;
      collectionHash: ReadonlyUint8Array;
      assetDataHash: ReadonlyUint8Array;
      flags: number;
    };

export function getLeafSchemaEncoder(): Encoder<LeafSchemaArgs> {
  return getDiscriminatedUnionEncoder([
    [
      'V1',
      getStructEncoder([
        ['id', getAddressEncoder()],
        ['owner', getAddressEncoder()],
        ['delegate', getAddressEncoder()],
        ['nonce', getU64Encoder()],
        ['dataHash', fixEncoderSize(getBytesEncoder(), 32)],
        ['creatorHash', fixEncoderSize(getBytesEncoder(), 32)],
      ]),
    ],
    [
      'V2',
      getStructEncoder([
        ['id', getAddressEncoder()],
        ['owner', getAddressEncoder()],
        ['delegate', getAddressEncoder()],
        ['nonce', getU64Encoder()],
        ['dataHash', fixEncoderSize(getBytesEncoder(), 32)],
        ['creatorHash', fixEncoderSize(getBytesEncoder(), 32)],
        ['collectionHash', fixEncoderSize(getBytesEncoder(), 32)],
        ['assetDataHash', fixEncoderSize(getBytesEncoder(), 32)],
        ['flags', getU8Encoder()],
      ]),
    ],
  ]);
}

export function getLeafSchemaDecoder(): Decoder<LeafSchema> {
  return getDiscriminatedUnionDecoder([
    [
      'V1',
      getStructDecoder([
        ['id', getAddressDecoder()],
        ['owner', getAddressDecoder()],
        ['delegate', getAddressDecoder()],
        ['nonce', getU64Decoder()],
        ['dataHash', fixDecoderSize(getBytesDecoder(), 32)],
        ['creatorHash', fixDecoderSize(getBytesDecoder(), 32)],
      ]),
    ],
    [
      'V2',
      getStructDecoder([
        ['id', getAddressDecoder()],
        ['owner', getAddressDecoder()],
        ['delegate', getAddressDecoder()],
        ['nonce', getU64Decoder()],
        ['dataHash', fixDecoderSize(getBytesDecoder(), 32)],
        ['creatorHash', fixDecoderSize(getBytesDecoder(), 32)],
        ['collectionHash', fixDecoderSize(getBytesDecoder(), 32)],
        ['assetDataHash', fixDecoderSize(getBytesDecoder(), 32)],
        ['flags', getU8Decoder()],
      ]),
    ],
  ]);
}

export function getLeafSchemaCodec(): Codec<LeafSchemaArgs, LeafSchema> {
  return combineCodec(getLeafSchemaEncoder(), getLeafSchemaDecoder());
}

// Data Enum Helpers.
export function leafSchema(
  kind: 'V1',
  data: GetDiscriminatedUnionVariantContent<LeafSchemaArgs, '__kind', 'V1'>
): GetDiscriminatedUnionVariant<LeafSchemaArgs, '__kind', 'V1'>;
export function leafSchema(
  kind: 'V2',
  data: GetDiscriminatedUnionVariantContent<LeafSchemaArgs, '__kind', 'V2'>
): GetDiscriminatedUnionVariant<LeafSchemaArgs, '__kind', 'V2'>;
export function leafSchema<K extends LeafSchemaArgs['__kind'], Data>(
  kind: K,
  data?: Data
) {
  return Array.isArray(data)
    ? { __kind: kind, fields: data }
    : { __kind: kind, ...(data ?? {}) };
}

export function isLeafSchema<K extends LeafSchema['__kind']>(
  kind: K,
  value: LeafSchema
): value is LeafSchema & { __kind: K } {
  return value.__kind === kind;
}
